import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const PRICING_SCHEDULES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('PRICING_SCHEDULES');
export const PRICING_SCHEDULES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	PRICING_SCHEDULES_CRUD_ACTION_CONSTANTS
);
